<template>
  <div v-if="!datosDog">
    <!-- Datos que rellenar -->
    <div v-for="(dato, index) in datosRellenar" :key="`${dato.id}_${index}`">    
      <ins-dog-datos :data="dato"></ins-dog-datos>
    </div>
    <!-- documentos que adjuntar -->
    <div v-for="(doc, index) in docsRellenar" :key="`${doc.id}_${index}` ">
    <ins-dog-document :data="doc"></ins-dog-document>
    </div>    
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import InsDogDocument from "./Inscriptions-dog-documents-comp";
import InsDogDatos from "./Inscriptions-dog-datos-comp";

export default {
  name: "Inscriptions-doc-required-comp",
  props: ["datosDog", "tarifa"],
  components:{
    InsDogDocument,
    InsDogDatos
  },
  methods: {},
  computed: {
    datosRellenar() {
      console.log(this.datosDog.docsDatos.datos)
      return this.datosDog.docsDatos.datos;
    },
    docsRellenar() {
      return this.datosDog.docsDatos.docs;
    },
    book() {
      // return this.datosDog.docsDatos.book;
      if (
        this.datosDog.docsDatos.book === 35 &&
        ( this.datosDog.class_selected !== "muy cachorros" &&
          this.datosDog.class_selected !== "cachorros" )
      ) {
       return true;
      }
    }
  }
};
</script>

<style scoped>
</style>